<template>
  <div class="messenger-chat-user-joined-or-left-log-message">
    <widget-translate
      :keypath="translationKeyPath"
      tag="span"
      class="break-word"
    >
      <template v-slot:user>
        <span class="font-weight-semi-bold">
          <template v-if="isUserLeftLogMessageListItem(logItem) && logItem.all">{{ $t('chat.allAgents') }}</template>
          <template v-else>{{ logItem.fullName }}</template>
        </span>
      </template>
    </widget-translate>
    <span class="messenger-chat-user-joined-or-left-log-message__time">&nbsp;&nbsp;{{ formattedTime }}</span>
  </div>
</template>

<script lang="ts" setup>
import {
  isUserLeftLogMessageListItem,
  type MessengerUserJoinedLogMessageListItem,
  type MessengerUserLeftLogMessageListItem,
} from '@widgets/messenger/types/chat/message'
import WidgetTranslate from '@widgets/shared/components/WidgetTranslate.vue'
import DateTimeService, { DATE_FORMAT } from '@widgets/shared/services/dateTimeService'
import { computed } from '@/composition/vue/compositionApi'

const props = defineProps<{
  logItem: MessengerUserJoinedLogMessageListItem | MessengerUserLeftLogMessageListItem
}>()

const translationKeyPath = computed(() => {
  return props.logItem.logType === 'userJoined' ? 'chat.userJoinedChat' : 'chat.userLeftChat'
})

const formattedTime = computed(() => {
  return DateTimeService.format(props.logItem.messageTime, DATE_FORMAT.TIME)
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.messenger-chat-user-joined-or-left-log-message {
  line-height: 20px;
  text-align: center;

  &__time {
    font-size: 12px;
    line-height: 16px;
    color: $distinct;
    white-space: nowrap;
  }
}
</style>
